import { IconArrowTurnRightOutline18 as RedirectIcon } from "nucleo-ui-outline-18"

import { mutators } from "@productlane/zero/mutators"

import { toast } from "@/components/toast"
import { mutateOk, useZero } from "@/lib/zero"

export function useRemoveRedirect() {
	const zero = useZero()
	return async (articleId: string, urlName: string) => {
		try {
			await mutateOk(
				zero.mutate(
					mutators.helpCenterArticles.removeRedirect({
						id: articleId,
						urlName,
					}),
				),
				"server",
			)
			toast.success({
				icon: RedirectIcon,
				title: "Redirect removed",
				description:
					"The old URL stops opening this article within a few minutes.",
			})
		} catch (error) {
			toast.error({
				title: "Couldn't remove the redirect",
				description: error instanceof Error ? error.message : undefined,
			})
		}
	}
}
